

export default {
  name: 'PageTypography',
  head() {
    return this.$utils.head(this.story)
  },
}
